import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getBranch } from './get-branch';

/** `PATCH /client/:cid/branches/:id {hub_id}`. */
export const changeHub = async (branch_id: string, hub_id: string): Promise<any> => {
  await lpRequest('PATCH', clientPath(`/branches/${branch_id}`), { body: { hub_id } });

  return getBranch(branch_id);
};
